module.exports = __webpack_public_path__ + "img/WhoAmI.99e74135.png";